import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { RevealDirective } from '../../core/directives/reveal.directive';

@Component({
  selector: 'hx-contact-section',
  standalone: true,
  imports: [RouterLink, RevealDirective],
  template: `
    <section id="contact" class="section-tight">
      <div class="wrap">
        <div class="case-panel single-col reveal" appReveal>
          <div>
            <span class="case-tag">Get in touch</span>
            <h3>Tell us what you're building.</h3>
            <p style="max-width:520px">
              Send a short brief and we'll come back with scope, timeline, and next steps — usually
              within two business days.
            </p>
            <div class="hero-actions" style="margin-top:24px">
              <a href="mailto:info@hexacorp.xyz" class="btn btn-primary">info&#64;hexacorp.xyz</a>
              <a routerLink="/promotions" class="btn btn-ghost">Referral program →</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  `,
})
export class ContactSectionComponent {}
